// import external dependencies

import "jquery"

// Import everything from autoload
import "./autoload/_bootstrap.js"

// Menu Scroll Box-shadow

  $(window).scroll(function(){
    if ($(window).scrollTop() > 40) {
        $('.header').addClass('scroll');
    }
    else {
        $('.header').removeClass('scroll')
    }
});


// Menu Activ Parent Link

function extraUrlCondition() {

    $('.menu-item-has-children>a').on('click', function (event) {
        event.preventDefault();
        window.location.href = $(this).attr('href')
    });

if ($(window).width() < 992) {
    $('.menu-item-has-children').each(function () {
        $(this).append('<span class="el-for-click"><i class="fa fa-plus" aria-hidden="true"></i></span>');
    });
    $('.el-for-click').on('click', function (event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $(this).parent().find('.dropdown-menu').toggleClass('show');
    })
}
}

//Hero Parallax

$(window).bind('scroll',function(){
    parallaxScroll();
});
 
function parallaxScroll(){
    var scrolled = $(window).scrollTop();
    var parallaxPoint = function(){
    if($(window).width() > 992) {
        $('#parallax').css('top',(0+(scrolled*.15))+'px');
        $('#parallax-logo').css('top',(251-(scrolled*.25))+'px');
    }}
    parallaxPoint();
}

// Buttons resize

jQuery(document).ready(() => {
    extraUrlCondition()

    $("#ChangeFontSizeButton1").click(function() {
        $(".content_size").css("font-size", "25px");
        $(".content_size").css("line-height", "35px");
        $(".info").css("font-size", "50px");
    });
    $("#ChangeFontSizeButton2").click(function() {
        $(".content_size").css("font-size", "32px");
        $(".content_size").css("line-height", "40px");
        $(".info").css("font-size", "55px");
    });
    $("#ChangeFontSizeButton3").click(function() {
        $(".content_size").css("font-size", "37px");
        $(".content_size").css("line-height", "45px");
        $(".info").css("font-size", "60px");
    });

    $("#ChangeFontSizeButtonPost1").click(function() {
        $(".type-page").css("font-size", "16px");
        $(".type-post").css("font-size", "16px");
    });
    $("#ChangeFontSizeButtonPost2").click(function() {
        $(".type-page").css("font-size", "150%");
        $(".type-post").css("font-size", "150%");
    });
    $("#ChangeFontSizeButtonPost3").click(function() {
        $(".type-page").css("font-size", "200%");
        $(".type-post").css("font-size", "200%");
    });

    
});

//Menu active parent when active child

$('.menu-item .active').parent().parent().addClass('active-child');
function secondChild() {

    let parent = $('.menu-item');
    if(parent.hasClass('.menu-item-588') || parent.hasClass('.active')) {
        $('.menu-item').parent().parent().addClass('active-child111111');
    }
}
secondChild()

$('.sidebar-links').children().eq(2).attr("target","_blank");






// WEBPACK FOOTER //
// ./scripts/main.js